import React, { useState } from "react";
import { useParams } from "react-router-dom";
//import { Identity } from "../../../../components/Identity";
import { PageTopbar } from "../../../../components/Page/Topbar";
import { PageHeader } from "../../../../components/Page/Header";
import { AppArticlesProductActionsDepot } from "../../../../app/Articles/Product/Actions/Depot";
import { getPageTitle } from "../../../../app/helpers/global";

export function RoutesArticlesProductActionsDepot({ parents, current }) {

    let identifier = (parents+current).replaceAll('/', '-');
    let group = parents.indexOf('articles/depot')===-1 ? 'location' : 'depot';

    const { productId } = useParams();
    const [ title, setTitle] = useState(null);

    if (title === null) {
        getPageTitle('product', productId, setTitle);
    }

    return (
        <div>
            
            <PageTopbar
                parents={parents}
                current={current}
            />
            
            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                tabGroup={"product-details-" + group}
                variables={{productId:productId}}
                identifier={identifier}
            />

            <AppArticlesProductActionsDepot
                parents={parents}
                productId={productId}
                identifier={identifier}
            />
        </div>
    );
}